import React from 'react'
import { withRouter } from 'react-router'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './CustomerList.css'

const CustomerListUI = ({context, messageList, customerList,
    // filters
    searchFilter, onSearchFilterChange,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick}) =>
  <div className='c_custs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick }
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI>
      {
        customerList.map((customer, i) =>
          <CustomerRowUI key={i} context={context} customer={customer}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({context, messageList, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick}) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
        {
          context.permissions.includes('acc_manage') &&
          <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_customer' />
        }
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        {
          selectedCount === 1 &&
          <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_customer' />
        }
        {
          selectedCount === 1 &&
          <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_delete_customer' />
        }
      </div>
    }
  </React.Fragment>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

const CustomerRowUI = ({context, messageList, customer, onRowClick}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} customer={customer} onRowClick={onRowClick} />}
    right={<RowRightUI customer={customer} messageList={messageList} />}
    onClick={onRowClick}
    rowId={customer.customerId}
  />

const RowLeftUI = ({context, customer, onRowClick}) =>
  <React.Fragment>
    {/* if React.Fragment is replaced with html element
      must add flex to the html element */}
    {
      context.permissions.includes('acc_manage') &&
      <input type="checkbox" className='checkbox' checked={customer.selected} onChange={() => {}} />
    }
    <label className='name'>
      {customer.customerName}
    </label>
  </React.Fragment>

const RowRightUI = ({customer, messageList}) =>
  <span />

export default withRouter(CustomerListUI)
